/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateShopOrderDto } from '../../models/create-shop-order-dto';
import { ShopOrder } from '../../models/shop-order';

export interface ShopControllerCreateOrder$Params {
      body: CreateShopOrderDto
}

export function shopControllerCreateOrder(http: HttpClient, rootUrl: string, params: ShopControllerCreateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrder>> {
  const rb = new RequestBuilder(rootUrl, shopControllerCreateOrder.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopOrder>;
    })
  );
}

shopControllerCreateOrder.PATH = '/api/shop/order';
